import { render, staticRenderFns } from "./AlertsComponent.vue?vue&type=template&id=84c9169c&scoped=true&"
import script from "./AlertsComponent.vue?vue&type=script&lang=js&"
export * from "./AlertsComponent.vue?vue&type=script&lang=js&"
import style0 from "./AlertsComponent.vue?vue&type=style&index=0&id=84c9169c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c9169c",
  null
  
)

export default component.exports